<template lang="pug">
  .container-reg-1
    el-steps(align-center).reg-steps
      el-step(title="填写账号密码", status="finish")
      el-step(title="完善商家资料")
      el-step(title="绑定联系方式")
    c-header-small
      template(slot="left")
        h3 填写账号密码
    .data-block
      data-row(label="账号", required)
        el-input(v-model="regForm.uname", placeholder='账号',auto-complete="off")
      data-row(value-only).grey.small 请输入 6 ~ 20 位字母或数字作登陆账号
    .data-block
      data-row(label="密码", required)
        el-input(type="password", v-model="regForm.passwd", placeholder='密码', auto-complete="off")
      data-row(value-only).grey.small 密码长度应为 8 ~ 20 位
      data-row(label="重复密码", required)
        el-input(type="password", v-model="regForm.confirm_passwd", @keyup.enter.native="reg", placeholder='密码', auto-complete="off")
    el-button(type="primary", @click="reg", :disabled="isReg").reg-button 注册
</template>

<script>
export default {
  data () {
    return {
      regForm:  {
        uname:          '',
        passwd:         '',
        confirm_passwd: '',
      },
      register_key:   '',
      isReg:      false,
      loading:    false,
    };
  },
  computed: {
    isMobile () {
      return window.browserInfo.isMobile;
    },
  },
  methods: {
    next () {
      this.$router.replace('/reg-mobile/2');
    },
    toDesktop () {
      this.$router.replace({ path: '/reg/1', query: this.$route.query });
    },

    getRegisterKey (app_id, redirect_url, remark) {
      const params = { app_id, redirect_url, remark };
      return this.$store.dispatch('START_REGISTRY', params).then((register_key) => {
        this.register_key = register_key;
        return register_key;
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `注册流程初始化失败：${code}：${msg}`
        });
      });
    },

    reg () {
      if (this.regForm.uname.length < 6 || this.regForm.uname.length > 20) {
        this.$message({
          type:     'warning',
          message:  `账号长度应为 6 ~ 20 位`
        });
        return;
      } else if (this.regForm.passwd.length < 8 || this.regForm.passwd.length > 20) {
        this.$message({
          type:     'warning',
          message:  `密码长度应为 8 ~ 20 位`
        });
        return;
      } else if (this.regForm.passwd !== this.regForm.confirm_passwd) {
        this.$message({
          type:     'warning',
          message:  `两次输入的密码不一致`
        });
        return;
      }

      this.isReg = true;
      this.loading = true;

      const params = Object.assign({}, this.regForm, {
        register_key:   this.register_key
      });
      this.$store.dispatch('REGISTRY', params).then(() => {
        this.$store.dispatch('LOGIN', this.regForm).then(() => {
          this.next();
        }).catch(({ code, msg }) => {
          this.$message({
            type:     'error',
            message:  `登录失败：${code}：${msg}`
          });
        }).finally(() => {
          this.loading = false;
        });
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `注册失败：${code}：${msg}`
        });
      }).finally(() => {
        this.isReg = false;
        this.loading = false;
      });
    },
  },
  mounted () {
    if (!this.isMobile) {
      this.toDesktop();
    } else {
      const query = this.$route.query;
      if (query.app_id && query.redirect_url) {
        const { app_id, redirect_url, remark } = query;
        this.getRegisterKey(app_id, redirect_url, remark);
      } else {
        this.$message({
          type:     'error',
          message:  `缺少注册流程初始化参数`
        });
      }
    }
  },
};
</script>
